import React, { memo } from 'react';
import { connect } from 'react-redux';
import {
  getVariations,
  showModal,
  closeModal,
  createVariation,
  editVariation,
  deleteVariation,
  finishSubmitVariation,
  finishDeleteVariation,
} from '../../store/variations/actions';
import { VARIATIONS_ACTIONS_TYPE } from '../../helpers/constants';

function withVariations(WrappedComponent) {
  const mapStateToProps = state => ({
    variations: state.variations.list,
    variationPersisted: state.variations.variation,
    variationError: state.variations.error,
    isLoadingVariations: state.variations.isLoading,
    isLoadingCreateVariation: state.variations.isLoadingCreate,
    isLoadingEditVariation: state.variations.isLoadingEdit,
    isLoadingDeleteVariation: state.variations.isLoadingDelete,
    isCreateVariationFinished: state.variations.isCreateVariationFinished,
    isEditVariationFinished: state.variations.isEditVariationFinished,
    isDeleteVariationFinished: state.variations.isDeleteVariationFinished,
    finishReceiveVariations: state.variations.finishReceiveVariations,
    showCreateVariantModal: state.variations.showCreateVariantModal,
    showEditVariantModal: state.variations.showEditVariantModal,
    showDeleteVariantModal: state.variations.showDeleteVariantModal,
  });

  const mapDispatchToProps = dispatch => ({
    getVariations: () => dispatch(getVariations()),
    createVariation: variation => dispatch(createVariation(variation)),
    editVariation: variation => dispatch(editVariation(variation)),
    deleteVariation: id => dispatch(deleteVariation(id)),
    finishSubmitVariation: () => dispatch(finishSubmitVariation()),
    finishDeleteVariation: () => dispatch(finishDeleteVariation()),
    showModal: (type, variation) => dispatch(showModal(type, variation)),
    closeModal: () => dispatch(closeModal()),
  });

  const VariationModalContainer = props => {
    const onClickVariationActions = type => {
      let action = {};
      VARIATIONS_ACTIONS_TYPE.forEach(item => {
        action[item.type] = item.type;
      });

      switch (type) {
        case action.edit:
          props.showModal(type, props.variation);
          break;
        case action.delete:
          props.showModal(type, props.variation);
          break;
        default:
          props.showModal();
          break;
      }
    };

    const isSubmiting = () => {
      return props.isLoadingCreateVariation || props.isLoadingEditVariation;
    };

    return (
      <WrappedComponent
        finishSubmitVariation={finishSubmitVariation}
        isSubmiting={isSubmiting}
        onClickVariationActions={onClickVariationActions}
        {...props}
      />
    );
  };

  const VariationModals = connect(
    mapStateToProps,
    mapDispatchToProps
  )(memo(VariationModalContainer));

  return VariationModals;
}

export default withVariations;



// WEBPACK FOOTER //
// ./src/containers/GlobalVariations/index.js